/* src/services/api.js */
import axios from 'axios'

const rawBaseUrl = process.env.VUE_APP_API_BASE_URL

const api = axios.create({
  baseURL: '/api/', 
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  }
})

api.interceptors.request.use(
  (config) => {

    const token = localStorage.getItem('user-token')
    
    if (token) {

      config.headers.Authorization = `Token ${token}`
    }

    console.debug("*** DEBUG localStorage.getItem('user-token')", localStorage.getItem('user-token'))
    return config
  },
  (error) => {

    console.debug("*** DEBUG Error", error)
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => response,
  (error) => {

    if (error.response && error.response.status === 401) {

      console.warn("Token non valido o scaduto. Redirect al login.")
      localStorage.removeItem('user-token')
    }
    return Promise.reject(error)
  }
)

export default api